<template>
  <div class="card">
    <img :src="work.image" class="card-img-top" @click="modalShow = true" :alt="work.name" />

    <button
      class="btn tag"
      v-if="filter === 'all'"
      :class="{
        'btn-success': work.group === 'vue',
        'btn-info': work.group === 'react',
        'btn-secondary': work.group === 'all',
        'btn-warning': work.group === 'email',
        'btn-dark': work.group === 'site'
      }"
    >
      {{
        work.group === 'site'
          ? 'Сайт'
          : work.group === 'all'
          ? 'Все работы'
          : work.group.charAt(0).toUpperCase() + work.group.slice(1)
      }}
    </button>

    <Ligthbox v-if="modalShow" :image="work.image" :modalShow="modalShow" @close="closeModal" />

    <div class="card-body">
      <h5 class="card-title" :title="work.title">
        {{ work.title }}
      </h5>
      <p class="card-text" :title="work.description">
        {{ work.description }}
      </p>
      <a :href="link" target="_blank" rel="nofollow noopener" class="btn btn-primary" v-if="work.group !== 'email'">
        Открыть <span v-if="work.group === 'site'">сайт</span>
      </a>
      <button class="btn btn-danger ms-3" v-if="currentUser" @click="deleteWork(work.id)">Удалить</button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Ligthbox from '@/components/Ligthbox';

export default {
  name: 'Work',
  data: () => ({
    baseUrl: 'https://a-gurkov.ru/',
    modalShow: false
  }),
  props: ['work', 'filter'],
  computed: {
    ...mapGetters('auth', ['currentUser']),
    link() {
      if (this.work.path.indexOf('web.app') > -1 || this.work.path.indexOf('.ru') > -1) {
        return this.work.path;
      } else {
        return `${this.baseUrl}${this.work.path}`;
      }
    }
  },
  methods: {
    async deleteWork(id) {
      this.$store.dispatch('works/deleteWork', id);
    },
    closeModal() {
      this.modalShow = false;
    }
  },
  components: {
    Ligthbox
  }
};
</script>

<style lang="scss" scoped>
@import '@/scss/_variables';

.card {
  position: relative;
  .tag {
    position: absolute;
    z-index: 1;
    top: 15px;
    right: 15px;
    pointer-events: none;
  }
  &-img-top {
    width: 100%;
    height: 150px;
    object-fit: cover;
    cursor: pointer;
  }
  &-text {
    overflow: hidden;
    text-overflow: ellipsis;
    min-height: 75px;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    &::-webkit-scrollbar {
      width: 0;
      display: none;
    }
  }

  .btn-success {
    background-color: $c-green;
    border-color: $c-green;
  }

  .btn-info {
    background-color: $c-turquoise;
    border-color: $c-turquoise;
  }
}
</style>
